var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unpined-chat-wrapper"},[(_vm.init)?_c('chat-window',{attrs:{"conversationId":_vm.conversationId,"currentThreadId":_vm.threadId,"unpined":""}}):_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }